// MD5 encryption utility
// Used for generating X-Sign header for API requests

// Basic MD5 implementation
function md5Encrypt(str) {
  const crypto = require('crypto');
  return crypto.createHash('md5').update(str).digest('hex');
}

export { md5Encrypt };


// WEBPACK FOOTER //
// ./src/utils/MD5.js